import { Flex, NumberInput } from "@gravity-ui/uikit";
import { Control, Controller } from "react-hook-form";

import { ProductFilters } from "../../ProductFilters";

export interface PriceRangeInputsProps {
  control: Control<ProductFilters>;
  minPlaceholder?: string;
  maxPlaceholder?: string;
}

export const PriceRangeInputs = ({
  control,
  minPlaceholder,
  maxPlaceholder,
}: PriceRangeInputsProps) => {
  return (
    <Flex alignItems={"center"} gap={2}>
      <Controller
        name="priceFrom"
        control={control}
        render={({ field }) => {
          return (
            <NumberInput
              placeholder={minPlaceholder}
              hiddenControls
              {...field}
            />
          );
        }}
      />
      <span>—</span>
      <Controller
        name="priceTo"
        control={control}
        render={({ field }) => {
          return (
            <NumberInput
              placeholder={maxPlaceholder}
              hiddenControls
              {...field}
            />
          );
        }}
      />
    </Flex>
  );
};
